export const generateDownload = (downloadUrl: string, fileName = 'file', format = '.pdf'): void => {
  const a = document.createElement('a')
  a.href = downloadUrl
  a.download = fileName + format
  document.body.appendChild(a)
  a.click()
  URL.revokeObjectURL(downloadUrl)
  document.body.removeChild(a)
}
